<template>
  <div class="cbox pageContainer weijiPage flexCloumn">
    <el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
      <div class="flexStart flex_1">
        <el-date-picker size="small" v-model="dateArray" type="datetimerange" :picker-options="pickerOptions"
          range-separator="至" start-placeholder="开始投递时间" end-placeholder="结束投递时间" align="right"
          class="input-with-select" style="width:255px;margin-right: 10px"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <tchtree v-model="searchForm.class_id"></tchtree>
        <el-input placeholder="企业名称" v-model="searchForm.firm_name" size="small" class="input-with-select"
          style="width:150px;margin-left: 10px" clearable></el-input>
        <el-input placeholder="姓名或学号" v-model="searchForm.stu_where" size="small" class="input-with-select"
          style="width:150px;margin-left: 10px" clearable></el-input>

        <el-select v-model="searchForm.status" clearable placeholder="投递状态" size="small"
          style="width:130px;margin-left:10px">
          <el-option label="全部" value></el-option>
          <el-option :label="item.param_desc" v-for="(item, idx) in tdzt" :key="idx" :value="(idx + 1)"></el-option>
        </el-select>
        <el-select v-model="searchForm.interview_status" clearable placeholder="面试状态" size="small"
          style="width:130px;margin-left:10px">
          <el-option label="全部" value></el-option>
          <el-option :label="item.param_desc" v-for="(item, idx) in mszt" :key="idx" :value="(idx + 1)"></el-option>
        </el-select>
        <el-select v-model="searchForm.hire_status" clearable placeholder="录用状态" size="small"
          style="width:130px;margin-left:10px">
          <el-option label="全部" value></el-option>
          <el-option :label="item.param_desc" v-for="(item, idx) in lyzt" :key="idx" :value="(idx + 1)"></el-option>
        </el-select>
        <el-button icon="el-icon-search" style="margin-left:10px" size="small" type="primary"
          @click="() => { page.current_page = 1; getList() }">搜索</el-button>
        <el-button size="small" icon="el-icon-download" type="primary" @click="export_excel">导出数据</el-button>
        <el-button v-if="$store.state.config.sync_data" icon="el-icon-refresh" style="margin-left: 10px;" size="small"
          type="primary" @click="tongbuJava">迁移老版本</el-button>

      </div>
    </el-row>
    <div class="dividerBar"></div>
    <div class="bcontent">
      <el-table v-tableFit :data="tableData" row-key="id" border stripe>
        <el-table-column type="index" label="序号" width="55px" align="center"></el-table-column>
        <el-table-column label="职位" prop="job_name" width="150px" align="center"></el-table-column>
        <el-table-column label="企业名称" prop="firm_name" width="150px" align="center"></el-table-column>
        <el-table-column label="学号" prop="stu_num" width="150px" align="center"></el-table-column>
        <el-table-column label="姓名" prop="stu_name" width="100px" align="center"></el-table-column>
        <el-table-column label="班级" prop="bj_name" min-width="100px" align="center"></el-table-column>
        <el-table-column label="年级" prop="nj_name" min-width="100px" align="center"></el-table-column>
        <el-table-column label="院系" prop="yx_name" min-width="100px" align="center"></el-table-column>
        <el-table-column label="投递时间" prop="create_date" width="200px" align="center"></el-table-column>
        <el-table-column label="投递状态" prop="status" width="100px" align="center">
          <template slot-scope="scope">{{ scope.row.status > 0 ? tdzt[scope.row.status - 1].param_desc : ""
            }}</template>
        </el-table-column>
        <el-table-column label="面试状态" prop="interview_status" width="100px" align="center">
          <template slot-scope="scope">{{ scope.row.interview_status > 0 ? mszt[scope.row.interview_status - 1
            ].param_desc : "" }}</template>
        </el-table-column>
        <el-table-column label="录用状态" prop="hire_status" width="100px" align="center">
          <template slot-scope="scope">{{ scope.row.hire_status > 0 ? lyzt[scope.row.hire_status - 1].param_desc : ""
            }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-tag class="pointer" @click="handleModify(scope.row)" type="peimary" size="mini">简历详情</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right;padding-top: 10px;">
        <el-pagination background @current-change="handlePageChange" :current-page="page.current_page"
          :page-size="page.per_page" :total="page.count" layout="total, prev, pager, next"></el-pagination>
      </div>
    </div>
    <el-dialog ref="ruleForm" title="简历详情" :visible.sync="dialogForm" :close-on-click-modal="false" width="80%"
      top="2px">
      <el-form :model="formData" label-width="100px" v-if="tdzt.length > 0 && mszt.length > 0 && lyzt.length > 0">
        <el-row>
          <el-col :span="3" align="middle">
            <el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="srcList"></el-image>
          </el-col>
          <el-col :span="21">
            <el-row>
              <el-col :span="24">
                <div style="width: 100px; text-align: right; font-size: 20px;padding-bottom: 15px;font-weight: 900;">
                  <span style>{{ formData.stu_name }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="联系电话">: {{ formData.tel }}</el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="微信号">: {{ formData.wechat }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="性别">: {{ formData.sex == 1 ? "男" : formData.sex == 2 ? "女" : "" }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出生日期">: {{ formData.birthday }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="求职状态">: {{ formData.job_status === 0 || formData.job_status > 0 ? qzzt[formData.job_status].param_desc : "" }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="学校">: {{ formData.school_name }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="专业">: {{ formData.profession_name }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="毕业时间">: {{ formData.leave_time }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="附件简历">:
                  <template v-if="formData.annexes && formData.annexes.length > 0 && formData.annexes[0]">
                    <span @click="openAnnexResume(formData.annexes[0].src)" class="overText" style="cursor:pointer;color: #3378fa;">
                  <i class="el-icon-paperclip">简历附件</i>
                </span>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="个人优势">: {{ formData.advandage }}</el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="期望职位">
              :
              <span v-html="jobHtml"></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="实践经历">
              :
              <span v-html="practiceHtml"></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目经验">
              :
              <span v-html="projectHtml"></span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import tchtree from "../../com/tchTree.vue";
import citys from "../../../utils/arae_value.js";
import aesJs from "@/utils/aes";
export default {
  components: {
    tchtree
  },
  data() {
    return {
      dateArray: [],
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
      ],
      searchForm: {
        firm_name: "",
        stu_where: "",
        start_time: "",
        end_time: "",
        class_id: "",
        status: "",
        interview_status: "",
        hire_status: ""
      },
      tableData: [],
      dialogForm: false,
      formData: {},
      jobHtml: "",
      practiceHtml: "",
      projectHtml: "",
      tdzt: [],
      mszt: [],
      lyzt: [],
      xzfw: [],
      qzzt: [],
      page: {
        count: 0,
        current_page: 1,
        per_page: 11,
        total_page: 0
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getComType().then(rr => {
      this.getList();
    });
  },
  methods: {
    getComType() {
      return new Promise(resolve => {
        this.$http
          .post("/api/sys_param_list", {
            param_type: "'TDZT','LYZT','MSZT','SALARY_RANGE','QZZT'",
            used: 0
          })
          .then(res => {
            let tdzt = []; //投递状态
            let mszt = []; //面试状态
            let lyzt = []; //录用状态
            let xzfw = []; //薪资类型
            let qzzt = []
            for (let item of res.data) {
              if (item.param_type == "TDZT") {
                tdzt.push(item);
              }
              if (item.param_type == "SALARY_RANGE") {
                xzfw.push(item);
              }
              if (item.param_type == "MSZT") {
                mszt.push(item);
              }
              if (item.param_type == "LYZT") {
                lyzt.push(item);
              }
              if (item.param_type == "QZZT") {
                qzzt.push(item);
              }
            }
            this.tdzt = tdzt;
            this.mszt = mszt;
            this.lyzt = lyzt;
            this.xzfw = xzfw;
            this.qzzt = qzzt
            resolve();
          });
      });
    },
    getList() {
      this.searchForm.start_time =
        this.dateArray.length > 0 ? this.dateArray[0] : "";
      this.searchForm.end_time =
        this.dateArray.length > 0 ? this.dateArray[1] : "";
      this.searchForm.page = this.page.current_page;
      this.$http.post("/api/zp_delivery_list", this.searchForm).then(res => {
        this.tableData = res.data.data;
        this.page = res.data.page;
      });
    },
    handleModify(row) {
      this.$http.post("/api/zp_resume_info", { id: row.stu_id }).then(async res => {
        res.data = await aesJs.decrypt(res.data)
        res.data = JSON.parse(res.data)
        console.log(res.data)
        this.formData = res.data;
        this.jobHtml = "";
        this.practiceHtml = "";
        this.projectHtml = "";
        this.formData.job_array.forEach(info => {
          let obj = this.getParentId(citys, info.city);
          this.jobHtml +=
            "<span>&nbsp;&nbsp;" +
            info.type_name +
            "&nbsp;&nbsp;|&nbsp;&nbsp;" +
            this.xzfw[info.pay].param_desc +
            "&nbsp;&nbsp;|&nbsp;&nbsp;" +
            obj.label +
            "<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        });
        this.formData.practice && JSON.parse(this.formData.practice).forEach(info1 => {
          this.practiceHtml += `<span>&nbsp;&nbsp;公司名称 : &nbsp;${info1.enterName}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>&nbsp;&nbsp;起止时间 : &nbsp;${info1.startDate}&nbsp;-&nbsp;${info1.endDate}</span> </br>
        <span>&nbsp;&nbsp;所属行业 : &nbsp;${info1.industry_name}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>&nbsp;&nbsp;职位类型 : &nbsp;${info1.job_type_name}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>&nbsp;&nbsp;所属部门 : &nbsp;${info1.dept}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>&nbsp;&nbsp;工作内容 : &nbsp;${info1.perfor}</span> </br>
        <span>&nbsp;&nbsp;工作业绩 : &nbsp;${info1.jobContent}</span> </br></br>`;
        });
        this.formData.project && JSON.parse(this.formData.project).forEach(info2 => {
          this.projectHtml += `<span>&nbsp;&nbsp;项目名称:&nbsp;${info2.name}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>&nbsp;&nbsp;起止时间 : &nbsp;${info2.startDate}&nbsp;-&nbsp;${info2.endDate}</span> </br>
         <span>&nbsp;&nbsp;项目描述 : &nbsp;${info2.projDesc}</span></br>
        <span>&nbsp;&nbsp;担任角色 : &nbsp;${info2.role}</span></br>`;
          if (info2.annex.length > 0) {
            this.projectHtml += ` <span>&nbsp;&nbsp;项目附件 : &nbsp;`;
            JSON.parse(info2.annex).forEach(info3 => {
              this.projectHtml += `<a href="${info3.fileUrl}">${info3.fileName}</a></br>`;
            });
            this.projectHtml += `</span></br></br>`;
          } else {
            this.projectHtml += `</br>`;
          }
        });
        this.dialogForm = true;
      });
    },
    export_excel() {
      this.searchForm.start_time =
        this.dateArray.length > 0 ? this.dateArray[0] : "";
      this.searchForm.end_time =
        this.dateArray.length > 0 ? this.dateArray[1] : "";
      this.searchForm.page = this.page.current_page;
      this.$http
        .post("/api/export_zp_delivery_excel", this.searchForm)
        .then(res => {
          if (res.data.url) {
            window.open(res.data.url);
          }
        });
    },
    handlePageChange(page) {
      this.page.current_page = page;
      this.getList();
    },
    getParentId(list, iid) {
      if (list && list.length > 0) {
        for (let o of list) {
          if (o.value == iid) return o;
          const o_ = this.getParentId(o.children, iid);
          if (o_) return o_;
        }
      }
    },
    tongbuJava() {
      this.$confirm('请确保JAVA版本已存在？是否继续同步?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let loadingInstance = this.$loading({
          lock: true,
          text: "已发送请求，请稍等...",
          spinner: 'el-icon-loading'
        })
        this.$http.post("/api/sync_zp_delivery", {}).then(res => {
          loadingInstance.close()
          this.$message.success('后台同步中，请刷新查看')
          this.getList();
        }).catch(err => {
          this.$message.error('同步失败')
          loadingInstance.close()
        })

      }).catch(() => {

      });
    },
    openAnnexResume(url) {
      let path = url
      const fileExtension = path.split('.').pop().toLowerCase()
      if (fileExtension === 'ppt' || fileExtension === 'pptx' || fileExtension === 'doc' || fileExtension === 'docx') {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path))
      } else {
        // window.open('http://www.pfile.com.cn/api/profile/onlinePreview?url=' + encodeURIComponent(path));
        window.open(url, "_blank")
      }
    },
  }
};
</script>
<style scoped>
/deep/ .el-form-item {
  margin-bottom: 0px;
}
</style>